import { useState, useEffect } from "react";
import {
  getSozlesmeler, addSozlesme, deleteSozlesme,
  getAylikRapor, toggleFatura, getCariListesi, getSiparisler
} from "../services/api";

const AYLAR = [
  "","Ocak","Subat","Mart","Nisan","Mayis","Haziran",
  "Temmuz","Agustos","Eylul","Ekim","Kasim","Aralik"
];

const fmt = (n) => n == null ? "-" : Number(n).toLocaleString("tr-TR", { minimumFractionDigits: 2 }) + " TL";

const TABS = [
  { id: "liste", label: "Sozlesmeler", icon: "📋" },
  { id: "rapor", label: "Aylik Rapor", icon: "📊" },
];

function CariRehberi({ onSelect, onClose }) {
  const [carilar, setCarilar] = useState([]);
  const [search, setSearch]   = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCariListesi()
      .then(r => setCarilar(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const filtered = carilar.filter(c =>
    (c.CARI_KOD || "").toLowerCase().includes(search.toLowerCase()) ||
    (c.CARI_ISIM || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 1000,
    }}>
      <div style={{
        background: "var(--bg-sidebar)", border: "1px solid var(--accent-bg)", borderRadius: 12,
        width: 580, maxHeight: "70vh", display: "flex", flexDirection: "column",
        boxShadow: "0 25px 50px rgba(0,0,0,0.5)",
      }}>
        <div style={{ padding: "16px 20px", borderBottom: "1px solid var(--border-hairline)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontSize: 15, fontWeight: 600, color: "var(--accent-text)" }}>Cari Rehberi</div>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "var(--text-muted)", fontSize: 20, cursor: "pointer", lineHeight: 1 }}>x</button>
        </div>
        <div style={{ padding: "12px 20px", borderBottom: "1px solid var(--border-hairline)" }}>
          <input
            autoFocus
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Cari kodu veya isim ara..."
            style={{
              width: "100%", background: "var(--bg-card)", border: "1px solid var(--border)",
              borderRadius: 7, padding: "8px 12px", color: "var(--text-primary)", fontSize: 13,
              outline: "none", boxSizing: "border-box",
            }}
          />
        </div>
        <div style={{ overflowY: "auto", flex: 1 }}>
          {loading && <div style={{ padding: 32, textAlign: "center", color: "var(--text-faint)", fontSize: 13 }}>Yukleniyor...</div>}
          {!loading && filtered.length === 0 && <div style={{ padding: 32, textAlign: "center", color: "var(--text-faint)", fontSize: 13 }}>Sonuc bulunamadi.</div>}
          {filtered.map((c, i) => (
            <div key={i} onClick={() => onSelect(c)}
              style={{ padding: "10px 20px", cursor: "pointer", borderBottom: "1px solid #0f1f3d", display: "flex", gap: 16, alignItems: "center" }}
              onMouseEnter={e => e.currentTarget.style.background = "var(--bg-card-alt)"}
              onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
              <span style={{ fontSize: 12, fontWeight: 600, color: "#60a5fa", minWidth: 90 }}>{c.CARI_KOD}</span>
              <span style={{ fontSize: 13, color: "var(--text-primary)" }}>{c.CARI_ISIM}</span>
            </div>
          ))}
        </div>
        <div style={{ padding: "10px 20px", borderTop: "1px solid var(--border-hairline)", fontSize: 12, color: "var(--text-faint)" }}>
          {filtered.length} kayit listeleniyor
        </div>
      </div>
    </div>
  );
}

export default function DestekSozlesme() {
  const [tab, setTab]                 = useState("liste");
  const [sozlesmeler, setSozlesmeler] = useState([]);
  const [rapor, setRapor]             = useState([]);
  const [loading, setLoading]         = useState(false);
  const [msg, setMsg]                 = useState(null);
  const [showRehber, setShowRehber]   = useState(false);
  const [siparisler, setSiparisler]   = useState([]);
  const [siparisLoading, setSiparisLoading] = useState(false);
  const [mailLoading, setMailLoading] = useState(false);
  const [editSiparis, setEditSiparis] = useState(null); // { sozlesmeId, cariKodu, mevcutNo }
  const [editSiparisler, setEditSiparisler] = useState([]);
  const [editSiparisLoading, setEditSiparisLoading] = useState(false);
  const [editSecilen, setEditSecilen] = useState("");
  const [kontrolLoading, setKontrolLoading] = useState(false);
  // inline fatura no seçici: { faturaId, cariKodu } veya null
  const [editFaturaNo, setEditFaturaNo] = useState(null);
  const [editFaturaListesi, setEditFaturaListesi] = useState([]);
  const [editFaturaLoading, setEditFaturaLoading] = useState(false);
  const [editFaturaSecilen, setEditFaturaSecilen] = useState("");
  const [odemeLoading, setOdemeLoading] = useState(false);
  const [odemeSonuclari, setOdemeSonuclari] = useState({}); // { faturaId: "Ödendi" | "Ödenmedi" | "Kısmi Ödendi" | "Bilgi Yok" }

  const today = new Date();
  const [secYil, setSecYil] = useState(today.getFullYear());
  const [secAy,  setSecAy]  = useState(today.getMonth() + 1);

  const [form, setForm] = useState({
    cari_kodu: "", cari_ismi: "",
    destek_tutari: "", fatura_periyodu: "aylik",
    baslangic_tarihi: today.toISOString().slice(0, 10),
    netsis_siparis_no: "",
  });

  useEffect(() => {
    if (tab === "liste") loadSozlesmeler();
    if (tab === "rapor") loadRapor();
  }, [tab, secYil, secAy]);

  async function loadSozlesmeler() {
    setLoading(true);
    try { setSozlesmeler((await getSozlesmeler()).data); }
    catch { flash("Yuklenemedi", "error"); }
    finally { setLoading(false); }
  }

  async function loadRapor() {
    setLoading(true);
    try { setRapor((await getAylikRapor(secYil, secAy)).data); }
    catch { flash("Rapor yuklenemedi", "error"); }
    finally { setLoading(false); }
  }

  function flash(text, type = "success") {
    setMsg({ text, type });
    setTimeout(() => setMsg(null), 4000);
  }

  async function handleMailGonder() {
    if (!window.confirm(`${AYLAR[secAy]} ${secYil} için hatırlatma maili gönderilsin mi?`)) return;
    setMailLoading(true);
    try {
      const res = await fetch("/api/scheduler/send-now", { method: "POST" });
      const data = await res.json();
      if (data.status === "ok") flash("✅ Mail başarıyla gönderildi!", "success");
      else flash("❌ Mail gönderilemedi: " + data.message, "error");
    } catch (e) {
      flash("❌ Bağlantı hatası: " + e.message, "error");
    } finally {
      setMailLoading(false);
    }
  }

  async function handleCariSec(cari) {
    setForm({ ...form, cari_kodu: cari.CARI_KOD, cari_ismi: cari.CARI_ISIM, netsis_siparis_no: "" });
    setShowRehber(false);
    setSiparisLoading(true);
    setSiparisler([]);
    try {
      const res = await getSiparisler(cari.CARI_KOD);
      setSiparisler(res.data);
    } catch { }
    finally { setSiparisLoading(false); }
  }

  async function handleAdd(e) {
    e.preventDefault();
    try {
      await addSozlesme({ ...form, destek_tutari: parseFloat(form.destek_tutari) });
      flash("Sozlesme eklendi");
      setForm({ cari_kodu: "", cari_ismi: "", destek_tutari: "", fatura_periyodu: "aylik", baslangic_tarihi: today.toISOString().slice(0, 10), netsis_siparis_no: "" });
      setSiparisler([]);
      loadSozlesmeler();
    } catch (err) {
      flash(err.response?.data?.detail || "Hata", "error");
    }
  }

  async function handleDelete(id, ismi) {
    if (!confirm(`"${ismi}" silinsin mi?`)) return;
    try {
      await deleteSozlesme(id);
      flash("Silindi");
      loadSozlesmeler();
    } catch { flash("Silinemedi", "error"); }
  }

  async function handleToggle(sozlesmeId) {
    try {
      await toggleFatura({ sozlesme_id: sozlesmeId, yil: secYil, ay: secAy });
      loadRapor();
    } catch { flash("Guncellenemedi", "error"); }
  }

  async function handleTopluKontrol() {
    setKontrolLoading(true);
    try {
      const res = await fetch(
        `/api/contracts/rapor/toplu-kontrol?yil=${secYil}&ay=${secAy}`,
        { method: "POST" }
      );
      const data = await res.json();
      if (data.status === "ok") {
        const bulunan = data.sonuclar.filter(s => s.FisNo).length;
        const isaretlenen = data.sonuclar.filter(s => s.OtomatikIsaretlendi).length;
        loadRapor();
        flash(`✅ ${bulunan} fatura bulundu, ${isaretlenen} yeni işaretlendi`, "success");
      }
    } catch (e) {
      flash("Kontrol hatası: " + e.message, "error");
    } finally {
      setKontrolLoading(false);
    }
  }

  async function handleFaturaNoEdit(r) {
    setEditFaturaNo({ faturaId: r.FaturaID, cariKodu: r.CariKodu });
    setEditFaturaSecilen("");
    setEditFaturaListesi([]);
    setEditFaturaLoading(true);
    try {
      const res = await fetch(
        `/api/contracts/rapor/fatura-listesi?cari_kodu=${encodeURIComponent(r.CariKodu)}&yil=${secYil}&ay=${secAy}`
      );
      const data = await res.json();
      setEditFaturaListesi(data);
    } catch { }
    finally { setEditFaturaLoading(false); }
  }

  async function handleFaturaNoKaydet() {
    if (!editFaturaNo || !editFaturaSecilen) return;
    try {
      await fetch(
        `/api/contracts/rapor/${editFaturaNo.faturaId}/fatura-no`,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ fatura_no: editFaturaSecilen }),
        }
      );
      flash("Fatura no kaydedildi");
      setEditFaturaNo(null);
      loadRapor();
    } catch {
      flash("Kaydedilemedi", "error");
    }
  }

  async function handleOdemeKontrol() {
    setOdemeLoading(true);
    setOdemeSonuclari({});
    try {
      const res = await fetch(
        `/api/contracts/rapor/odeme-kontrol?yil=${secYil}&ay=${secAy}`,
        { method: "POST" }
      );
      const data = await res.json();
      if (data.status === "ok") {
        const map = {};
        data.sonuclar.forEach(s => { map[s.FaturaID] = s.OdemeDurumu; });
        setOdemeSonuclari(map);
        const odendi = data.sonuclar.filter(s => s.OdemeDurumu === "Ödendi").length;
        const kismi  = data.sonuclar.filter(s => s.OdemeDurumu === "Kısmi Ödendi").length;
        const odenmedi = data.sonuclar.filter(s => s.OdemeDurumu === "Ödenmedi").length;
        flash(`💰 ${odendi} ödendi, ${kismi} kısmi, ${odenmedi} ödenmedi`, "success");
      }
    } catch (e) {
      flash("Ödeme kontrol hatası: " + e.message, "error");
    } finally {
      setOdemeLoading(false);
    }
  }

  async function handleSiparisNoEdit(r) {
    setEditSiparis({ sozlesmeId: r.SozlesmeID, cariKodu: r.CariKodu, mevcutNo: r.NetsisSiparisNo || "" });
    setEditSecilen(r.NetsisSiparisNo || "");
    setEditSiparisler([]);
    setEditSiparisLoading(true);
    try {
      const res = await getSiparisler(r.CariKodu);
      setEditSiparisler(res.data);
    } catch { }
    finally { setEditSiparisLoading(false); }
  }

  async function handleSiparisNoKaydet() {
    if (!editSiparis) return;
    try {
      await fetch(`/api/contracts/${editSiparis.sozlesmeId}/siparis-no`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ netsis_siparis_no: editSecilen }),
      });
      flash("Sipariş no güncellendi");
      setEditSiparis(null);
      loadRapor();
    } catch {
      flash("Güncellenemedi", "error");
    }
  }

  const toplam       = rapor.reduce((s, r) => s + (r.Tutar || 0), 0);
  const faturalanmis = rapor.filter(r => r.Faturalanmis).reduce((s, r) => s + (r.Tutar || 0), 0);
  const bekleyen     = toplam - faturalanmis;

  const card = { background: "var(--bg-card-alt)", border: "1px solid var(--accent-bg)", borderRadius: 10, padding: 20 };
  const th   = { padding: "10px 14px", textAlign: "left", fontWeight: 600, fontSize: 12, color: "var(--text-muted)", borderBottom: "1px solid var(--border-hairline)", textTransform: "uppercase", letterSpacing: ".05em" };
  const td   = { padding: "11px 14px", fontSize: 13, color: "var(--text-primary)", borderBottom: "1px solid var(--border-hairline)" };
  const inp  = { background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 7, padding: "8px 11px", color: "var(--text-primary)", fontSize: 13, outline: "none", width: "100%", boxSizing: "border-box" };
  const btn  = (bg, color) => ({ background: bg, color, border: "none", borderRadius: 7, padding: "9px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer" });

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>

      {showRehber && <CariRehberi onSelect={handleCariSec} onClose={() => setShowRehber(false)} />}

      {msg && (
        <div style={{
          padding: "11px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500,
          background: msg.type === "error" ? "#3f1515" : "#0f3d20",
          border: `1px solid ${msg.type === "error" ? "#dc2626" : "#16a34a"}`,
          color: msg.type === "error" ? "#fca5a5" : "#86efac",
        }}>{msg.text}</div>
      )}

      <div style={{ display: "flex", gap: 6, borderBottom: "1px solid var(--border-hairline)", paddingBottom: 0 }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            background: "none", border: "none", cursor: "pointer",
            padding: "8px 16px", fontSize: 14, fontWeight: tab === t.id ? 600 : 400,
            color: tab === t.id ? "var(--accent-text)" : "var(--text-muted)",
            borderBottom: tab === t.id ? "2px solid var(--accent)" : "2px solid transparent",
            marginBottom: -1,
          }}>
            {t.icon} {t.label}
          </button>
        ))}
      </div>

      {tab === "liste" && (
        <>
          <div style={card}>
            <div style={{ fontSize: 14, fontWeight: 600, color: "var(--accent-text)", marginBottom: 16 }}>Yeni Sozlesme Ekle</div>
            <form onSubmit={handleAdd}>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))", gap: 12, marginBottom: 14 }}>

                <div>
                  <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>CARI KODU</div>
                  <div style={{ display: "flex", gap: 6 }}>
                    <input style={{ ...inp, flex: 1 }} placeholder="Rehberden secin" value={form.cari_kodu} readOnly required />
                    <button type="button" onClick={() => setShowRehber(true)}
                      style={{ background: "var(--accent-bg)", border: "1px solid var(--border)", borderRadius: 7, color: "var(--accent-text)", padding: "0 10px", cursor: "pointer", fontSize: 16, flexShrink: 0 }}
                      title="Cari Rehberi">🔍</button>
                  </div>
                </div>

                <div>
                  <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>CARI ISMI</div>
                  <input style={{ ...inp, color: "var(--text-secondary)" }} placeholder="Otomatik dolacak" value={form.cari_ismi} readOnly />
                </div>

                <div>
                  <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>NETSIS SIPARIS NO</div>
                  {siparisLoading ? (
                    <div style={{ ...inp, color: "var(--text-faint)" }}>Yukleniyor...</div>
                  ) : siparisler.length > 0 ? (
                    <select style={inp} value={form.netsis_siparis_no}
                      onChange={e => setForm({ ...form, netsis_siparis_no: e.target.value })}>
                      <option value="">Secin...</option>
                      {siparisler.map((s, i) => (
                        <option key={i} value={s.FATIRS_NO}>{s.FATIRS_NO}</option>
                      ))}
                    </select>
                  ) : (
                    <input style={{ ...inp, color: "var(--text-secondary)" }}
                      placeholder={form.cari_kodu ? "Siparis bulunamadi" : "Once cari secin"}
                      value={form.netsis_siparis_no}
                      onChange={e => setForm({ ...form, netsis_siparis_no: e.target.value })}
                    />
                  )}
                </div>

                <div>
                  <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>DESTEK TUTARI (TL)</div>
                  <input style={inp} type="number" step="0.01" placeholder="0.00" value={form.destek_tutari} required
                    onChange={e => setForm({ ...form, destek_tutari: e.target.value })} />
                </div>

                <div>
                  <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>PERIYOT</div>
                  <select style={inp} value={form.fatura_periyodu} onChange={e => setForm({ ...form, fatura_periyodu: e.target.value })}>
                    <option value="aylik">Aylik</option>
                    <option value="yillik">Yillik</option>
                  </select>
                </div>

                <div>
                  <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>BASLANGIC TARIHI</div>
                  <input style={inp} type="date" value={form.baslangic_tarihi} required
                    onChange={e => setForm({ ...form, baslangic_tarihi: e.target.value })} />
                </div>

              </div>
              <button type="submit" style={btn("var(--accent)", "#fff")}>Sozlesme Ekle</button>
            </form>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 14 }}>
            {[
              { label: "Toplam Sozlesme", value: sozlesmeler.length + " adet", color: "var(--text-primary)" },
              { label: "Aylik Periyotlu", value: sozlesmeler.filter(s => s.FaturaPeriyodu === "aylik").length + " adet", color: "#60a5fa" },
              { label: "Yillik Periyotlu", value: sozlesmeler.filter(s => s.FaturaPeriyodu === "yillik").length + " adet", color: "#34d399" },
            ].map(k => (
              <div key={k.label} style={{ ...card, padding: 16 }}>
                <div style={{ fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: ".05em" }}>{k.label}</div>
                <div style={{ fontSize: 24, fontWeight: 700, color: k.color, marginTop: 6 }}>{k.value}</div>
              </div>
            ))}
          </div>

          <div style={{ ...card, padding: 0, overflow: "hidden" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "var(--bg-sidebar)" }}>
                  {["Cari Kodu","Cari Ismi","Siparis No","Destek Tutari","Periyot","Aylik Tutar","Baslangic","Bitis",""].map(h => (
                    <th key={h} style={th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading && <tr><td colSpan={10} style={{ ...td, textAlign: "center", color: "var(--text-faint)", padding: 32 }}>Yukleniyor...</td></tr>}
                {!loading && sozlesmeler.length === 0 && <tr><td colSpan={9} style={{ ...td, textAlign: "center", color: "var(--text-faint)", padding: 32 }}>Henuz sozlesme eklenmemis.</td></tr>}
                {sozlesmeler.map(s => (
                  <tr key={s.ID}
                    onMouseEnter={e => e.currentTarget.style.background = "var(--bg-card-alt)"}
                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                    <td style={{ ...td, color: "#60a5fa", fontWeight: 600 }}>{s.CariKodu}</td>
                    <td style={td}>{s.CariIsmi}</td>
                    <td style={{ ...td, color: "var(--text-secondary)" }}>{s.NetsisSiparisNo || "-"}</td>
                    <td style={{ ...td, textAlign: "right" }}>{fmt(s.DestekTutari)}</td>
                    <td style={td}>
                      <span style={{
                        padding: "3px 9px", borderRadius: 99, fontSize: 11, fontWeight: 600,
                        background: s.FaturaPeriyodu === "aylik" ? "var(--accent-bg)" : "#0d3b2e",
                        color: s.FaturaPeriyodu === "aylik" ? "var(--accent-text)" : "#34d399",
                      }}>
                        {s.FaturaPeriyodu === "aylik" ? "Aylik" : "Yillik"}
                      </span>
                    </td>
                    <td style={{ ...td, textAlign: "right", color: "#34d399", fontWeight: 600 }}>
                      {s.FaturaPeriyodu === "aylik" ? fmt(s.DestekTutari / 12) : fmt(s.DestekTutari)}
                    </td>
                    <td style={{ ...td, color: "var(--text-secondary)" }}>{s.BaslangicTarihi?.slice(0,10)}</td>
                    <td style={{ ...td, color: "var(--text-secondary)" }}>{s.BitisTarihi?.slice(0,10)}</td>
                    <td style={td}>
                      <button onClick={() => handleDelete(s.ID, s.CariIsmi)}
                        style={{ background: "#3f1515", color: "#fca5a5", border: "1px solid #7f1d1d", borderRadius: 6, padding: "4px 10px", fontSize: 11, cursor: "pointer" }}>
                        Sil
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {tab === "rapor" && (
        <>
          <div style={{ ...card, display: "flex", gap: 14, alignItems: "flex-end", flexWrap: "wrap" }}>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>YIL</div>
              <select style={{ ...inp, width: 100 }} value={secYil} onChange={e => setSecYil(+e.target.value)}>
                {[today.getFullYear()-1, today.getFullYear(), today.getFullYear()+1].map(y => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>AY</div>
              <select style={{ ...inp, width: 130 }} value={secAy} onChange={e => setSecAy(+e.target.value)}>
                {AYLAR.slice(1).map((a, i) => (
                  <option key={i+1} value={i+1}>{a}</option>
                ))}
              </select>
            </div>
            <button onClick={loadRapor} style={btn("var(--accent-bg)", "var(--accent-text)")}>Yenile</button>

            {/* MAİL GÖNDER BUTONU */}
            <div style={{ marginLeft: "auto", display: "flex", gap: 10, alignItems: "flex-end" }}>
              <div>
                <button
                  onClick={handleTopluKontrol}
                  disabled={kontrolLoading}
                  style={{
                    ...btn(kontrolLoading ? "#1a1a2e" : "#1e1b4b", kontrolLoading ? "var(--text-faint)" : "#a5b4fc"),
                    border: "1px solid #4338ca",
                    opacity: kontrolLoading ? 0.7 : 1,
                    display: "flex", alignItems: "center", gap: 7,
                  }}
                >
                  {kontrolLoading ? "⏳ Kontrol ediliyor..." : "🔍 Toplu Fatura Kontrol"}
                </button>
                <div style={{ fontSize: 11, color: "var(--text-faint)", marginTop: 5, textAlign: "right" }}>
                  Sistemdeki faturaları otomatik eşleştir
                </div>
              </div>
              <div>
                <button
                  onClick={handleOdemeKontrol}
                  disabled={odemeLoading}
                  style={{
                    ...btn(odemeLoading ? "#1a1f2e" : "#1a1a3e", odemeLoading ? "var(--text-faint)" : "#c4b5fd"),
                    border: "1px solid #7c3aed",
                    opacity: odemeLoading ? 0.7 : 1,
                    display: "flex", alignItems: "center", gap: 7,
                  }}
                >
                  {odemeLoading ? "⏳ Kontrol ediliyor..." : "💰 Ödeme Kontrolü"}
                </button>
                <div style={{ fontSize: 11, color: "var(--text-faint)", marginTop: 5, textAlign: "right" }}>
                  Tahsilat durumunu sorgula
                </div>
              </div>
              <div>
                <button
                  onClick={handleMailGonder}
                  disabled={mailLoading}
                  style={{
                    ...btn(mailLoading ? "#1a2a1a" : "#0d3b2e", mailLoading ? "var(--text-faint)" : "#34d399"),
                    border: "1px solid #16a34a",
                    opacity: mailLoading ? 0.7 : 1,
                    display: "flex", alignItems: "center", gap: 7,
                  }}
                >
                  {mailLoading ? "⏳ Gönderiliyor..." : "✉️ Hatırlatma Maili Gönder"}
                </button>
                <div style={{ fontSize: 11, color: "var(--text-faint)", marginTop: 5, textAlign: "right" }}>
                  {AYLAR[secAy]} {secYil} faturalanmamışlar için
                </div>
              </div>
            </div>
          </div>


          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 14 }}>
            {[
              { label: "Toplam", value: fmt(toplam), color: "var(--text-primary)", border: "var(--accent-bg)" },
              { label: "Faturalandı", value: fmt(faturalanmis), color: "#34d399", border: "#0d3b2e" },
              { label: "Bekleyen", value: fmt(bekleyen), color: "#fb923c", border: "#431407" },
            ].map(k => (
              <div key={k.label} style={{ ...card, padding: 16, borderColor: k.border }}>
                <div style={{ fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: ".05em" }}>{k.label}</div>
                <div style={{ fontSize: 22, fontWeight: 700, color: k.color, marginTop: 6 }}>{k.value}</div>
              </div>
            ))}
          </div>

          <div style={{ ...card, padding: 0, overflow: "hidden" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "var(--bg-sidebar)" }}>
                  {["Cari Kodu","Cari Ismi","Siparis No","Periyot","Aylik Tutar","Durum","Fatura No","Fatura Tarihi","Ödeme","Islem"].map(h => (
                    <th key={h} style={th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading && <tr><td colSpan={10} style={{ ...td, textAlign: "center", color: "var(--text-faint)", padding: 32 }}>Yukleniyor...</td></tr>}
                {!loading && rapor.length === 0 && <tr><td colSpan={10} style={{ ...td, textAlign: "center", color: "var(--text-faint)", padding: 32 }}>Bu ay icin kayit bulunamadi.</td></tr>}
                {rapor.map(r => (
                  <tr key={r.FaturaID}
                    onMouseEnter={e => e.currentTarget.style.background = "var(--bg-card-alt)"}
                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                    <td style={{ ...td, color: "#60a5fa", fontWeight: 600 }}>{r.CariKodu}</td>
                    <td style={td}>{r.CariIsmi}</td>
                    <td style={{ ...td, color: "var(--text-secondary)", minWidth: 160 }}>
                      {editSiparis?.sozlesmeId === r.SozlesmeID ? (
                        <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
                          {editSiparisLoading ? (
                            <span style={{ fontSize: 12, color: "var(--text-faint)" }}>Yükleniyor...</span>
                          ) : editSiparisler.length > 0 ? (
                            <select
                              autoFocus
                              style={{ ...inp, width: 130, padding: "4px 8px", fontSize: 12 }}
                              value={editSecilen}
                              onChange={e => setEditSecilen(e.target.value)}
                            >
                              <option value="">Seçin...</option>
                              {editSiparisler.map((s, i) => (
                                <option key={i} value={s.FATIRS_NO}>{s.FATIRS_NO}</option>
                              ))}
                            </select>
                          ) : (
                            <input
                              autoFocus
                              style={{ ...inp, width: 130, padding: "4px 8px", fontSize: 12 }}
                              value={editSecilen}
                              onChange={e => setEditSecilen(e.target.value)}
                              placeholder="Manuel girin"
                            />
                          )}
                          <button onClick={handleSiparisNoKaydet}
                            style={{ background: "#0d3b2e", color: "#34d399", border: "1px solid #16a34a", borderRadius: 5, padding: "3px 8px", fontSize: 11, cursor: "pointer" }}>✓</button>
                          <button onClick={() => setEditSiparis(null)}
                            style={{ background: "#3f1515", color: "#fca5a5", border: "1px solid #7f1d1d", borderRadius: 5, padding: "3px 8px", fontSize: 11, cursor: "pointer" }}>✕</button>
                        </div>
                      ) : (
                        <span
                          onClick={() => handleSiparisNoEdit(r)}
                          title="Düzenlemek için tıklayın"
                          style={{ cursor: "pointer", borderBottom: "1px dashed var(--text-faint)", paddingBottom: 1 }}
                        >
                          {r.NetsisSiparisNo || "-"}
                        </span>
                      )}
                    </td>
                    <td style={td}>
                      <span style={{
                        padding: "3px 9px", borderRadius: 99, fontSize: 11, fontWeight: 600,
                        background: r.FaturaPeriyodu === "aylik" ? "var(--accent-bg)" : "#0d3b2e",
                        color: r.FaturaPeriyodu === "aylik" ? "var(--accent-text)" : "#34d399",
                      }}>
                        {r.FaturaPeriyodu === "aylik" ? "Aylik" : "Yillik"}
                      </span>
                    </td>
                    <td style={{ ...td, textAlign: "right", fontWeight: 600 }}>{fmt(r.Tutar)}</td>
                    <td style={td}>
                      {r.Faturalanmis
                        ? <span style={{ padding: "3px 10px", borderRadius: 99, fontSize: 11, fontWeight: 600, background: "#0d3b2e", color: "#34d399" }}>Faturalandı</span>
                        : <span style={{ padding: "3px 10px", borderRadius: 99, fontSize: 11, fontWeight: 600, background: "#2d1b00", color: "#fb923c" }}>Bekliyor</span>
                      }
                    </td>
                    <td style={{ ...td, minWidth: 160 }}>
                      {editFaturaNo?.faturaId === r.FaturaID ? (
                        <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
                          {editFaturaLoading ? (
                            <span style={{ fontSize: 12, color: "var(--text-faint)" }}>Yükleniyor...</span>
                          ) : (
                            <select
                              autoFocus
                              style={{ ...inp, width: 150, padding: "4px 8px", fontSize: 12 }}
                              value={editFaturaSecilen}
                              onChange={e => setEditFaturaSecilen(e.target.value)}
                            >
                              <option value="">Seçin...</option>
                              {editFaturaListesi.map((f, i) => (
                                <option key={i} value={f.FISNO}>{f.FISNO}</option>
                              ))}
                            </select>
                          )}
                          <button onClick={handleFaturaNoKaydet}
                            title="Kaydet"
                            style={{ background: "#0d3b2e", color: "#34d399", border: "1px solid #16a34a", borderRadius: 5, padding: "3px 8px", fontSize: 11, cursor: "pointer" }}>✓</button>
                          <button onClick={() => setEditFaturaNo(null)}
                            title="İptal"
                            style={{ background: "#3f1515", color: "#fca5a5", border: "1px solid #7f1d1d", borderRadius: 5, padding: "3px 8px", fontSize: 11, cursor: "pointer" }}>✕</button>
                        </div>
                      ) : r.FaturaNo ? (
                        <span
                          onClick={() => handleFaturaNoEdit(r)}
                          title="Değiştirmek için tıklayın"
                          style={{ color: "#34d399", fontWeight: 600, cursor: "pointer", borderBottom: "1px dashed #16a34a", paddingBottom: 1 }}
                        >
                          {r.FaturaNo}
                        </span>
                      ) : r.Faturalanmis ? (
                        <span
                          onClick={() => handleFaturaNoEdit(r)}
                          title="Fatura no eklemek için tıklayın"
                          style={{ color: "var(--text-faint)", cursor: "pointer", fontSize: 12, borderBottom: "1px dashed var(--border)", paddingBottom: 1 }}
                        >
                          + Fatura No Ekle
                        </span>
                      ) : (
                        <span style={{ color: "var(--text-ghost)", fontSize: 12 }}>—</span>
                      )}
                    </td>
                    <td style={{ ...td, color: "var(--text-secondary)", fontSize: 12 }}>
                      {r.FaturaTarihi ? r.FaturaTarihi.slice(0,10) : "-"}
                    </td>
                    <td style={td}>
                      {odemeSonuclari[r.FaturaID] ? (() => {
                        const d = odemeSonuclari[r.FaturaID];
                        const styles = {
                          "Ödendi":       { bg: "#0d3b2e", color: "#34d399" },
                          "Kısmi Ödendi": { bg: "#2d1f00", color: "#fbbf24" },
                          "Ödenmedi":     { bg: "#3f1515", color: "#fca5a5" },
                          "Bilgi Yok":    { bg: "var(--border-hairline)", color: "var(--text-muted)" },
                        }[d] || { bg: "var(--border-hairline)", color: "var(--text-muted)" };
                        return <span style={{ padding: "3px 9px", borderRadius: 99, fontSize: 11, fontWeight: 600, background: styles.bg, color: styles.color }}>{d}</span>;
                      })() : <span style={{ color: "var(--text-ghost)", fontSize: 12 }}>—</span>}
                    </td>
                    <td style={td}>
                      <button onClick={() => handleToggle(r.SozlesmeID)}
                        style={{
                          padding: "4px 12px", borderRadius: 6, border: "none", cursor: "pointer", fontSize: 11, fontWeight: 600,
                          background: r.Faturalanmis ? "#3f1515" : "#0d3b2e",
                          color: r.Faturalanmis ? "#fca5a5" : "#86efac",
                        }}>
                        {r.Faturalanmis ? "Geri Al" : "Faturalandı"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
